import React from 'react';
import MainCalculatorsList from '../MainCalculators';
import SharedHelmet from '../Helmet';
import RelatedLinks from '../RelatedLinks';
import { CalculatorsType } from '../ConstantsEN';
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
import SharedCubicMeterCalculator from './SharedCubicMeterCalculator';
const TITLE = 'Cubic Meters (CBM) Calculator - Calculate Cubic Meters Online';
const DESCRIPTION = 'This calculator calculates Calculate the cubic meters (CBM) volume or capacity for shipping, storage, or construction from measurements.';
const KEYWORDS = 'Calculate cubic meter';
const OG_URL = 'https://do-calculate.com/calculator/en/cubicmeter';
function Calculator() {
    return (
        <div className="ltr">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '40px' }}>
                        <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
                    </div>
                            <div className="border border-light">
                                <div className="row">
                                    <div>
                                        <p>
                                            The cubic meter is a measurement unit used to calculate the volume or capacity of different shapes. There are many geometric shapes that require specific equations to calculate their volume. If we consider a cube with a length of 2 meters, width of 2 meters, and height of 2 meters, we can use the equation for the volume of a cube, which is the length multiplied by the width multiplied by the height. This means that the volume of the cube would be 8 cubic meters.
                                        </p>
                                        <p>
                                            Using the cubic meter as a standard measurement unit simplifies volume and capacity calculations for various geometric shapes.
                                        </p>
                                        <hr />
                                    </div>
                                </div>
                                 <MobileUnderCalAds/>
                                <div className="row">
                                    <div className="col-sm-12 col-md-7 calculatorStyle">
                                        <div className='p-3 mb-2 bg-success text-white'>
                                            <h2 style={{ fontSize: '16px' }}>{TITLE}</h2>
                                        </div>
                                        <hr />
                                        <SharedCubicMeterCalculator />
                                    </div>
                                </div>
                                <hr />
                                <div className="row">
                                    <RelatedLinks />
                                    <hr />
                                </div>
                            </div>
                </div>
                <div className="col">
                    <SecondAds />
                    <br />
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.physicsCalculators} />
                    <br />
                </div>
            </div>
             <br />
        </div>
    );
}
export default Calculator;
